module.exports = __webpack_public_path__ + "static/media/info_icon.6701a4d7.svg";